import Table from 'react-bootstrap/Table';
import React, { useState } from 'react';
import TablePagination from '../../../../components/table/TablePagination';
import { useTranslation } from 'react-i18next';

export const HistoryGroupedTable = ({ content, totalElements }) => {

    const { t } = useTranslation();
    const [expandedRows, setExpandedRows] = useState([]);

    const toggleRow = (date) => {
        setExpandedRows((prev) =>
            prev.includes(date)
                ? prev.filter((value) => value !== date)
                : [...prev, date],
        );
    };

    return (
        <div className={'table-container'}>
            <Table bordered>
                <thead>
                <tr style={{ textAlign: 'center' }}>
                    <th>{t('history:productName')}</th>
                    <th>{t('history:action')}</th>
                    <th>{t('history:amount')}</th>
                    <th>{t('history:currentAmount')}</th>
                </tr>
                </thead>
                <tbody>
                {content.map((row) => (
                    <React.Fragment key={row.date}>
                        <tr onClick={() => toggleRow(row.date)} style={{ cursor: 'pointer' }} className={'center'}>
                            <td colSpan='4'>{row.date}</td>
                        </tr>
                        {expandedRows.includes(row.date)
                            ? (Array.from(Object.keys(row.products)).map(productName => {
                                let productActions = row.products[productName];
                                return productActions.map((item, index) =>
                                    <tr key={row.date + item.action} className={'expanded-rows center'}>
                                        {index === 0
                                            ? <td rowSpan={productActions.length}>{productName}</td>
                                            : <></>}
                                        <td><strong>{t('history:' + item.action)}</strong></td>
                                        <td><span>{item.amount}</span></td>
                                        <td><span>{item.currentAmount}</span></td>
                                    </tr>,
                                );
                            }))
                            : <></>}
                    </React.Fragment>
                ))}
                </tbody>
            </Table>
            <TablePagination totalElements={totalElements} />
        </div>
    );
};